export const ADMIN_VESSEL_PERMISSIONS = {
  view: 'adminVesselsView',
  create: 'adminVesselsCreate',
  update: 'adminVesselsUpdate',
  delete: 'adminVesselsDelete',
} as const;

export function isAdminSuperAdmin(role?: string): boolean {
  const normalized = (role || '').toLowerCase();
  return normalized === 'admin_super_admin' || normalized.includes('super_admin');
}

export function getAdminVesselAccess(role?: string, permissions: string[] = []) {
  const superAdmin = isAdminSuperAdmin(role) || permissions.includes('*');
  const canCreate = superAdmin || permissions.includes(ADMIN_VESSEL_PERMISSIONS.create);
  const canEdit = superAdmin || permissions.includes(ADMIN_VESSEL_PERMISSIONS.update);
  const canDelete = superAdmin || permissions.includes(ADMIN_VESSEL_PERMISSIONS.delete);
  const canView =
    superAdmin ||
    permissions.includes(ADMIN_VESSEL_PERMISSIONS.view) ||
    canCreate ||
    canEdit ||
    canDelete;

  return { canView, canCreate, canEdit, canDelete };
}
